import { styled } from 'styled-components'

export const MobileContainer = styled.div`
	/* Neutralise le max-width que SimulationGoalsContainer applique à ses enfants directs */
	max-width: initial !important;
`
